var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArmedForces(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2085_57178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8704 12.4792H9.16992V18.9535H14.8704V12.4792Z",
    fill: "#E7A484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5186 16.2894C10.5749 16.0899 9.73813 15.3377 9.17188 14.2575V13.2097L12.0208 13.3702L14.8697 13.2097V14.2575C14.3034 15.3377 13.4666 16.0899 12.523 16.2894C12.3933 16.317 12.261 16.334 12.1265 16.3398C12.125 16.3398 12.1234 16.3399 12.1218 16.34C12.0541 16.3428 11.9867 16.3428 11.9197 16.34C11.9181 16.3399 11.9166 16.3398 11.915 16.3398C11.7806 16.334 11.6483 16.317 11.5186 16.2894Z",
    fill: "#A65444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.003 8.45233C16.7222 7.78173 16.1486 8.11187 16.1486 8.11187C16.481 5.0667 14.9289 3.05664 12.021 3.05664C9.11303 3.05664 7.56087 5.0667 7.89163 8.11187C7.89163 8.11187 7.31797 7.78345 7.03717 8.45233C6.75637 9.12292 7.26973 10.6928 7.58671 11.1932C7.90369 11.6918 8.46529 11.5749 8.46529 11.5749C8.46529 11.5749 8.50147 12.6306 8.6479 13.0209C8.79433 13.4113 9.81417 15.7583 12.0192 15.7583C14.2243 15.7583 15.2441 13.4113 15.3906 13.0209C15.537 12.6306 15.5732 11.5319 15.5732 11.5319C15.5732 11.5319 16.1348 11.6935 16.4518 11.1932C16.7687 10.6945 17.2821 9.12292 17.0013 8.45233H17.003Z",
    fill: "#E7A484"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2085_57178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.13095 9.76211C9.04497 9.76758 8.35353 6.81757 9.07051 6.10241C9.43538 5.73936 9.96628 5.79957 10.4224 5.9145C10.9533 6.04951 11.5024 6.23377 12.0625 6.24836C12.6554 6.26478 13.2191 6.04586 13.7883 5.90903C14.2298 5.80139 14.7097 5.75396 15.0599 6.10241C15.7769 6.81574 15.0855 9.76576 15.9995 9.76211C15.9356 9.07979 15.9338 8.33362 16.4355 8.06362C16.7894 4.83265 15.1457 2.69995 12.0661 2.69995C8.98659 2.69995 7.34282 4.83265 7.69493 8.06362C8.10176 8.32815 8.19481 9.04878 8.13095 9.76211Z",
    fill: "#423209"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.47682 10.7583L8.34814 10.7668L8.40243 11.5783L8.5311 11.5698L8.47682 10.7583Z",
    fill: "#C46966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5755 10.758L15.5142 11.5259L15.6427 11.5361L15.7041 10.7682L15.5755 10.758Z",
    fill: "#C46966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41938 9.9635C7.23367 9.24821 7.2629 8.80974 7.51051 8.58105L7.5982 8.67563C7.39186 8.86649 7.37295 9.27572 7.5449 9.93084L7.41938 9.9635Z",
    fill: "#C46966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6515 9.9635L16.526 9.93084C16.6962 9.27572 16.679 8.86477 16.4727 8.67563L16.5603 8.58105C16.8097 8.80974 16.8389 9.24821 16.6515 9.9635Z",
    fill: "#C46966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9148 17.431C20.5338 17.7438 21.1944 19.127 21.1944 20.5635C21.9314 21.1308 22.243 21.6806 22.2349 22.2025C22.2785 24.6291 15.1422 25.9978 12.1523 25.9978C12.1028 25.9978 12.0519 25.9973 12 25.9963C11.948 25.9973 11.8972 25.9978 11.8476 25.9978C8.85772 25.9978 1.90677 24.9687 1.9504 22.5422C1.94233 22.0203 2.25393 21.4704 2.99085 20.9032C2.99085 19.4667 3.71338 17.7438 4.33236 17.431C6.3751 16.3989 9.16342 16.2771 9.16342 16.2771C9.83056 17.3094 10.9112 17.864 12 17.9309C13.0887 17.864 14.1694 17.3094 14.8365 16.2771C14.8365 16.2771 17.872 16.3989 19.9148 17.431Z",
    fill: "#9A7614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91687 17.3936L8.04971 16.2109L4.9434 16.9908L4.63428 18.0752L7.91687 17.3936Z",
    fill: "#423209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1285 17.3936L15.9957 16.2109L19.102 16.9908L19.4111 18.0752L16.1285 17.3936Z",
    fill: "#423209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28418 16.993L9.07969 15.5654L11.6556 17.8782L10.0786 19.6048L8.28418 16.993Z",
    fill: "#423209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7611 16.993L14.9656 15.5654L12.3896 17.8782L13.9647 19.6048L15.7611 16.993Z",
    fill: "#423209"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2085_57178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2085_57178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.83728,
    height: 7.06216,
    fill: "white",
    transform: "translate(7.64746 2.69995)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmedForces);
export default __webpack_public_path__ + "static/media/armedForces.f6510beb134f3c058a2449f17b494d9c.svg";
export { ForwardRef as ReactComponent };